export const NODE_TYPES = {
  ORGANISATION: 'ORGANISATION',
  OFFICE_LOCATION: 'OFFICE_LOCATION',
  VERTICAL: 'VERTICAL',
  DEPARTMENT: 'DEPARTMENT',
};

export const NODE_TYPE_LABELS = {
  ORGANISATION: 'Organisation',
  OFFICE_LOCATION: 'Office Location',
  VERTICAL: 'Vertical',
  DEPARTMENT: 'Department',
};

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  LOCKED: 'LOCKED',
};

export const CONTENT_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
};

export const PUSH_STATUS = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  CANCELLED: 'CANCELLED',
};

export const STATUS_VARIANTS = {
  ACTIVE: 'success',
  INACTIVE: 'warning',
  LOCKED: 'danger',
  INVITED: 'info',
  DRAFT: 'default',
  PUBLISHED: 'success',
  ARCHIVED: 'warning',
  SENT: 'success',
  SCHEDULED: 'info',
  CANCELLED: 'danger',
};

export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50];
